import _ from 'lodash';

const DimensionColumnCSVFormatter = (cell, row, rowIndex, column) => {
  const values = _.split(cell, ',');
  return _.join(_.map(values, (value) => (_.has(column.optionsKV, value) ? column.optionsKV[value] : value)), ', ');
};

export default DimensionColumnCSVFormatter;
